import { LOCALES } from '../constants';

export default {
  [LOCALES.ENGLISH]: {
    // new one
    'pagination':'pagination',
    'header':'header',
    'toolbar':'toolbar',
    'body':'body',
    // Side Menue
    "Project Management":"Project Management",
    'Dashboard':'Dashboard',
    'Calendar':'Calendar',
    'Kanban':'Kanban',
    'TimeLine':'TimeLine',
    'Gantt':'Gantt',
    'Notifications':'Notifications',
    'User Profile':'User Profile',
    // Create Project selector
    'Project type':'Project type',
    // Spreadsheet Column
    'Tasks ERP':'Tasks ERP',
    'Hardware':'Hardware',
    'Source':'Source',
    'Start':'Start',
    'Subject':'Subject',
    'Assigned To':'Assigned To',
    'Due Date':'Due Date',
    'Active?':'Active?',
    'Status':'Status',
    'Progress':'Progress',
    'Priority':'Priority',
    'Notes':'Notes',
    // Spreadsheet Action
    'Show last Modified':'Show last Modified',
    'Import Rows from csv':'Import Rows from csv',
    'Toogle single cell editing':'Toogle single cell editing',
    'Delete Multipe':'Delete Multipe',
    'Remove All Selected Tasks':'Remove All Selected Tasks',
    'Export':'Export',
    'Actions':'Actions',
    'no record to display':'no record to display',
    'Add':'Add',
    "Add Task":"Add Task",
    'Delete':'Delete',
    'Delete multipe':'Delete multipe',
    'Permanent delete':'Permanent delete',
    'Edit':'Edit',
    'Are you sure delete this row?':'Are you sure delete this row?',
    'Cancel':'Cancel',
    'Save':'Save',
    'Search':'Search',
    'rows':'rows',
    'First page':'First page',
    'Previous':'Previous',
    'Next':'Next',
    'Last page':'Last page',
    'of':'of',
    'Export to CSV':'Export to CSV',
    'Export to PDF':'Export to PDF',
    // csv Sync
    'Sync header field here with mode':'Sync header field here with mode',
    // ProjectKPI
    'Project Road Map':'Project Road Map',
    'Team member: ':'Team member: ',
    'Tasks Status':'Tasks Status',
    'Tasks Average Progress':'Tasks Average Progress',
    'Remaining days :':'Remaining days  :',
    'Task completed':'Task completed',
    'Assigned':'Assigned',
    'InProgress':'InProgress',
    'InReview':'InReview',
    'Completed':'Completed',
    'Suspended':'Suspended',
    // Project Selector
    'Modify':'Modify',
    'Add project':'Add project',
    'Project':'Project',
    'Select project':'Select project',
    'Project owner':'Project owner',
    'Collaborator':'Collaborator',
    'Not allowed for guest':'Not allowed for guest',
    'Delete forever ?':'Delete forever ?',
    // Cash financial Scenario Selector
    'Scenario':'Scenario',
    'Select scenario':'Select scenario',
    'Scenario owner':'Scenario owner',
    'Add scenario':'Add scenario',
    "Category":"Category",
    "Title":"Title",
    "Date":"Date",
    "Amount":"Amount",
    "Descriptions":"Descriptions",
    "Income":"Income",
    "Expense":"Expense",
    "Balance":"Balance",
    "Add Income":"Add Income",
    "Add Expense":"Add Expense",
    "Daily Flow":"Daily Flow",
    "Annual Report":"Annual Report",
    "Today":"Today",
    "Daily":"Daily",
    "Actual Cash Flow":"Actual Cash Flow",
    "Treasury":"Treasury",
    "Monthly":"Monthly",
    // Notification Page
    'Activity':'Activity',
    'Today Activity':'Today Activity',
    'demo-placeholder': 'Placeholder sample',
    // Others
    'Close':'Close',
    'Submit':'Submit',
    'ok':'ok',
    'Open':'Open',
    'Available':',Available',
    'Sign out':'Sign out',
    'Home':'Home',
    'organisation':'organisation',
    'Welcome':'Welcome',
    'Created':'Created',
    'Updated':'Updated',
    'email':'email',
    'Address':'Address',
    'Title':'Title',
    'id':'id',
    'Id':'Id',
    'New':'New',
    "b":"b",
    "tasksCompleted":"tasksCompleted",
    // other ERP Module/Departement
    'CRM':'CRM',
    "Contact Lists":"Contact Lists",
    "Activities":"Activities",
    "Deals":"Deals",
    "clients":"clients",
    "companies":"companies",
    "start":"start",
    "finish":"finish",
    "type":"type",
    "pipeline":"pipeline",
    'Cash Flow':'Cash Flow',
    'Test Components':'Test Components',
  },
};
